import script from "./AdminProductList.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminProductList.vue?vue&type=script&setup=true&lang=js"

import "./AdminProductList.vue?vue&type=style&index=0&id=3f070a70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f070a70"]])

export default __exports__